export default __webpack_public_path__ + "static/media/Info.2d6a6018.svg";